import script from "./MST01_008INS.vue?vue&type=script&setup=true&lang=js"
export * from "./MST01_008INS.vue?vue&type=script&setup=true&lang=js"

import "./MST01_008INS.vue?vue&type=style&index=0&id=566bc4c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-566bc4c3"]])

export default __exports__